export default "__VITE_ASSET__caa74783__"